module.exports = __webpack_public_path__ + "static/media/icons8-sound.d299ef7e.gif";